
import React from 'react';
import { Button } from "@/components/ui/button";
import { DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogBody } from "@/components/ui/dialog";
import ContactForm, { ContactFormData } from './ContactForm';

interface EditContactDialogProps {
  isMobile: boolean;
  formData: ContactFormData;
  setFormData: React.Dispatch<React.SetStateAction<ContactFormData>>;
  onEditContact: () => void;
}

const EditContactDialog: React.FC<EditContactDialogProps> = ({ 
  isMobile, 
  formData, 
  setFormData, 
  onEditContact 
}) => {
  return (
    <DialogContent className="sm:max-w-[550px]">
      <DialogHeader>
        <DialogTitle>Edit Contact</DialogTitle>
        <DialogDescription>
          Update the contact information.
        </DialogDescription>
      </DialogHeader>
      
      <DialogBody>
        <ContactForm formData={formData} setFormData={setFormData} />
      </DialogBody>
      
      <DialogFooter>
        <DialogClose asChild>
          <Button variant="outline">Cancel</Button>
        </DialogClose>
        <Button onClick={onEditContact}>Save Changes</Button>
      </DialogFooter>
    </DialogContent>
  );
};

export default EditContactDialog;
